
        module.exports = __webpack_public_path__ + "assets/images/send.6e48b6b0.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 40,
            height: 40,
            type: "png",
            bytes: 872,

            toString: function() {
                return src;
            }
        };
    